import styled, {css} from "styled-components"

interface Props {
  color?: string
}

export default styled.div<Props>`
  ${({theme, color}) => css`
    background-color: ${color || theme.colors.brand.default};
    width: 100%;
    height: 350px;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    ${theme.mediaQueries.minWidthMedia.tablet`
      height: 350px;
    `}
  `}
`
